import { useEffect } from "react";

interface PageMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogType?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  jsonLd?: object;
  imageAlt?: string;
}

export default function PageMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogUrl,
  ogType,
  twitterCard,
  twitterTitle,
  twitterDescription,
  jsonLd,
  imageAlt,
}: PageMetaProps) {
  useEffect(() => {
    document.title = title;

    const upsertMeta = (attr: string, value: string, content: string) => {
      let el: HTMLMetaElement | null = document.querySelector(
        `meta[${attr}="${value}"]`
      );
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, value);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    if (ogTitle) upsertMeta("property", "og:title", ogTitle);
    if (ogDescription) upsertMeta("property", "og:description", ogDescription);
    if (ogUrl) upsertMeta("property", "og:url", ogUrl);
    if (ogType) upsertMeta("property", "og:type", ogType);
    if (imageAlt) upsertMeta("name", "twitter:image:alt", imageAlt);
    if (twitterCard) upsertMeta("name", "twitter:card", twitterCard);
    if (twitterTitle) upsertMeta("name", "twitter:title", twitterTitle);
    if (twitterDescription)
      upsertMeta("name", "twitter:description", twitterDescription);

    if (canonicalUrl) {
      let link: HTMLLinkElement | null = document.querySelector(
        'link[rel="canonical"]'
      );
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
    }

    let jsonScript: HTMLScriptElement | null = document.querySelector(
      'script[type="application/ld+json"]'
    );
    if (jsonLd) {
      if (!jsonScript) {
        jsonScript = document.createElement("script");
        jsonScript.setAttribute("type", "application/ld+json");
        document.head.appendChild(jsonScript);
      }
      jsonScript.textContent = JSON.stringify(jsonLd);
    } else if (jsonScript) {
      jsonScript.textContent = "";
    }
  }, [
    title,
    description,
    keywords,
    canonicalUrl,
    ogTitle,
    ogDescription,
    ogUrl,
    ogType,
    twitterCard,
    twitterTitle,
    twitterDescription,
    jsonLd,
    imageAlt,
  ]);

  return null;
}

export function getSiteUrl(): string {
  if (typeof import.meta !== "undefined" && import.meta.env) {
    const url = (import.meta as Record<string, unknown>).env as Record<
      string,
      string
    >;
    return url.VITE_SITE_URL || "https://hipobuy.yachts";
  }
  return "https://hipobuy.yachts";
}